module.exports = __webpack_public_path__ + "static/img/stim-img.e94fa737.png";